import React from "react"

import { ExternalLink, Smartphone } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"
import { useApplication } from "@/contexts/ApplicationContext"
import { getAppStoreUrl } from "@/utils/deviceDetection"

const TrialConfirmation = () => {
  const appStoreUrl = getAppStoreUrl()
  const { application } = useApplication()

  return (
    <div className="mx-auto max-w-md">
      <Card>
        <CardHeader className="text-center">
          <div className="mb-4 flex justify-center">
            <div className="rounded-full bg-green-100 p-3">
              <Smartphone className="h-8 w-8 text-green-600" />
            </div>
          </div>
          <CardTitle className="mb-2 text-xl font-bold text-jungle">Congratulations!</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg bg-gray-50 p-4">
            <p className="text-sm text-gray-600">
              Congratulations you have been invited to pick up trial blocks with HIVED. Go to the
              HIVED team app to pick up your trial block.
            </p>
          </div>
          <div className="rounded-lg bg-gray-50 p-4">
            <p className="text-md text-gray-600">
              Your HIVED Person ID:{" "}
              <span className="font-bold">{application.airtablePersonId ?? ""}</span>
            </p>
          </div>
        </CardContent>
        <CardFooter className="flex flex-col space-y-3">
          {/* <a
            href="https://hived.space/team-app"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full"
          >
            <Button className="w-full bg-honeycomb hover:bg-amber-500 text-white">
              Go to HIVED Team App <ExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </a> */}
          <a href={appStoreUrl} target="_blank" rel="noopener noreferrer" className="w-full">
            <Button variant="outline" className="w-full bg-honeycomb text-white hover:bg-amber-500">
              Download HIVED Team App <ExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </a>
        </CardFooter>
      </Card>
    </div>
  )
}

export default TrialConfirmation
